import dayjs from 'dayjs';

export const getDateRangeByFilter = (filter, customRange = { start: null, end: null }) => {
    const today = dayjs();
    let startDate, endDate;

    switch (filter) {
        case 'today':
            startDate = today.startOf('day');
            endDate = today;
            break;
        case 'thisWeek':
            startDate = today.startOf('week');
            endDate = today.endOf('week');
            if (endDate.isAfter(today)) {
                endDate = today;
            }
            break;
        case 'lastWeek':
            startDate = today.subtract(1, 'week').startOf('week');
            endDate = today.subtract(1, 'week').endOf('week');
            break;
        case 'thisMonth':
            startDate = today.startOf('month');
            endDate = today.endOf('month');
            if (endDate.isAfter(today)) {
                endDate = today;
            }
            break;
        case 'lastMonth':
            startDate = today.subtract(1, 'month').startOf('month');
            endDate = today.subtract(1, 'month').endOf('month');
            break;
        case 'custom':
            if (customRange.start && customRange.end) {
                startDate = dayjs(customRange.start);
                endDate = dayjs(customRange.end);
                if (endDate.isAfter(today)) {
                    endDate = today;
                }
                if (startDate.isAfter(endDate)) {
                    startDate = endDate;
                }
            } else {
                startDate = today.subtract(7, 'days');
                endDate = today;
            }
            break;
        default:
            startDate = today.subtract(7, 'days');
            endDate = today;
    }

    return {
        start_date: startDate.format('YYYY-MM-DD'),
        end_date: endDate.format('YYYY-MM-DD'),
        start_date_unix: startDate.unix(),
        end_date_unix: endDate.unix()
    };
};

export const shouldFetchForFilter = (filter, customRange = { start: null, end: null }) => {
    if (filter === 'custom') {
        return Boolean(customRange.start && customRange.end);
    }
    return true;
}; 